__webpack_require__.p = "/manual-slots/referrals-hub/";